module.exports = __webpack_public_path__ + "static/media/rollerblade5.77075b90.gif";